import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';
// Current tags
// Add tag
// delete tag
// suggest tag
// current selected suggested tag

const CREATE_TASK_INSTANCE = gql`
  mutation createTaskInstance($object: String!, $tags: [String!], $description: String, $status: String, $due: DateTime, $name: String!) {
    createTaskInstance(object: $object, tags: $tags, description: $description, status:$status, due:$due, name: $name) {
      success
    }
  }
`;

Dispatch.getAction('task', 'update')
  .pipe(
    //_.find()
    //withLatestFrom(Dispatch.getState('States')),
    //map(([update, states]) => ({ States.}))
  )
  .subscribe(e => {
    Dispatch.mergeState('TaskBuffer.' + e.stateId, { [e.column]: e.value, saved: false })
    //Dispatch.mergeState('States.' + e.id + '.instance', { [e.column]: e.value, modified: true })
  })

Dispatch.getAction('task', 'save')
  .pipe(
    withLatestFrom(Dispatch.getState('States')),
    switchMap(([save, states]) => from(client.mutate({
      mutation: CREATE_TASK_INSTANCE,
      variables: { 
        object: states[save.stateId].object.id, 
        tags: {}, 
        description: states[save.stateId].instance.description, 
        status: states[save.stateId].instance.status, 
        due: new Date(states[save.stateId].instance.dueDate), 
        name: '', 
      },
    }))
    .pipe(
      //map(e => e[0]),
      //combineLatest(Dispatch.getState('States').pipe(skip(1))),
      tap(e => Dispatch.mergeState('TaskBuffer.' + save.stateId, { saved: true })),
      //startWith({})
    )
  ),
    // withLatestFrom(Dispatch.getState('TaskBuffer')),
    // map(([update, buffer]) => remove(buffer, update.id))
  )
  .subscribe(e => {
    //Dispatch.nextState('TaskBuffer.' + e.id, e)
    Dispatch.nextAction('Instance', 'created')
  })

  Dispatch.getAction('task', 'convert')
    .pipe(

    )

  Dispatch.getAction('task', 'temp')
    .pipe(

    )
    .subscribe(e => Dispatch.mergeState('TaskBuffer.' + e.id, { description: e.value, status: 'None', saved: false }))

Dispatch.getAction('task', 'cancel')
  .pipe(
    // withLatestFrom(Dispatch.getState('TaskBuffer')),
    // map(([update, buffer]) => remove(buffer, update.stateId))
  )
  .subscribe(e => Dispatch.mergeState('TaskBuffer.' + e.stateId, { saved: true }))

  // Dispatch.getAction('task', 'cancel')
  //   .pipe(
  //     withLatestFrom(Dispatch.getState('TaskBuffer')),
  //     map(([update, buffer]) => remove(buffer, update.stateId))
  //   )
  //   .subscribe(e => Dispatch.nextState('TaskBuffer', e))

  // const remove = (buffer, id) => {
  //   const newBuffer = buffer
  //   delete buffer[id]
  //   // //Re-add state otherwise it wont recalculate the changes on missing key
  //   // newBuffer[id] = {}
  //   return newBuffer
  // }